import { Component, Input } from '@angular/core';

@Component({
  selector: 'lib-fdp-details',
  standalone: true,
  imports: [],
  templateUrl: './fdp-details.component.html',
  styleUrl: './fdp-details.component.css',
})
export class FdpDetailsComponent {
  @Input() label = '';
}
